// @flow
import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import classnames from 'classnames';
import { themes } from 'Components/widgets/alternative-proposals/alternative-price/AlternativePrice.themes';
import type { IconName } from 'Components/frameworks/icon/Icon';

type Props = {|
  children: React$Node,
  iconName: IconName,
  onClick?: () => void,
  theme?: string,
|};

export const AlternativePriceCriteriaButton = ({
  children,
  iconName,
  onClick,
  theme = 'default',
}: Props) => {
  const { thButton, thHeightStyle, thIcon, thLabel } = themes[theme];

  return (
    <button className={thButton} style={thHeightStyle} onClick={onClick}>
      <Icon name={iconName} className={thIcon} width="1em" />
      <span
        className={classnames('alternative-price-criteria-label', thLabel)}
        style={thHeightStyle}
      >
        {children}
      </span>
    </button>
  );
};
